import React, { Component } from 'react'
import moment from 'moment'
import Button from '@material-ui/core/Button'
import { TextField } from '@material-ui/core'
import axios from 'axios'
import { CS_API_URL, CSNEW_API_URL, parseJwt } from '../lib/env'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'

class Comments extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: '',
      loading: false,
      error: false,
      comments: []
    }
  }

  componentDidMount() {
    this.setState({ comments: this.props.comments })
  }

  submitComment() {
    if (this.state.comment === '') {
      this.setState({ error: 'Введите текст сообщения!' })
      return
    }

    let self = this
    let comments = this.state.comments

    let user = parseJwt(localStorage.getItem('token'))
    console.log(user)

    comments.push({
      username: user.sub,
      userFullName: user.lastName + ' ' + user.firstName,
      createdDate: new Date(),
      text: this.state.comment
    })

    this.setState({ loading: true })

    let API_URL
    if (this.props.type === 'OPA') {
      API_URL = CSNEW_API_URL
    } else {
      API_URL = CS_API_URL
    }

    axios
      .patch(
        `${API_URL}/sales/updateValueComments`,
        {
          id: this.props.saleId,
          comments: this.state.comment,
          carFin: true
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then(response => {
        self.setState({
          comment: '',
          loading: false,
          comments: comments
        })
      })
      .catch(err => {
        console.log(err)
        self.setState({ loading: false })
      })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render() {
    return (
      <div>
        <div>
          {this.state.comments.length === 0 && (
            <div style={{ marginBottom: '10px', color: '#999' }}>
              Комментарии отсутствуют
            </div>
          )}

          {this.state.comments.map(comment => (
            <div style={{ padding: '5px', marginTop: '5px' }}>
              <div>{comment.userFullName}</div>
              <div style={{ fontSize: '12px' }}>
                {moment(comment.createdDate).format('HH:mm DD.MM.YYYY')}
              </div>
              <div style={{ fontWeight: 'bold', marginTop: '5px' }}>
                {comment.text}
              </div>
            </div>
          ))}
        </div>
        <div>
          <TextField
            variant="outlined"
            multiline={true}
            rows={3}
            style={{ minWidth: '350px', marginBottom: '5px' }}
            value={this.state.comment}
            onChange={this.handleChange('comment')}
          />
        </div>
        <div>
          {this.state.loading ? (
            <CircularProgress />
          ) : (
            <Button
              disabled={this.state.loading}
              onClick={this.submitComment.bind(this)}
              className="button_small button_grey_color"
            >
              Добавить комментарий
            </Button>
          )}
        </div>
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

export default flowRight(withSnackbar)(Comments)
